import reqwest from 'reqwest';
import Promise from 'Promise';
import mensagemHelper from '../helpers/mensagemHelper';
import mensagens from './messages';

export default class Http {
  static get(url, parameters) {
    mensagemHelper.mostrarLoading();

    return new Promise((resolve, reject) => {
      const done = _createDoneHandler(resolve);
      const fail = _createFailHandler(reject);

      reqwest({
        url: url,
        type: 'json',
        method: 'GET',
        contentType: 'application/json',
        data: parameters,
        success: done,
        error: fail
      });
    });
  }

  static post(url, parameters) {
    mensagemHelper.mostrarLoading();

    return new Promise((resolve, reject) => {
      const done = _createDoneHandler(resolve);
      const fail = _createFailHandler(reject);

      reqwest({
        url: url,
        type: 'json',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(parameters),
        success: done,
        error: fail
      });
    });
  }

  static postAjax(url, data) {
    return Http.ajax('post', url, data);
  }

  static ajax(method, url, data, type, contentType) {
    mensagemHelper.mostrarLoading();

    return reqwest({
      url,
      type: type || 'json',
      method,
      contentType: contentType || 'application/json',
      data,
      complete: (response) => {
        mensagemHelper.esconderLoading();

        if (response && response.status === 403) {
          const redirecionar = window.location.pathname;
          window.location.href = `/Seguranca/Seguranca/LogOn?ReturnUrl=${redirecionar}`;
        }
      },
    });
  }
}

const _createDoneHandler = (resolve) => {
  return (response) => {
    mensagemHelper.esconderLoading();
    var message = response.Mensagem && !response.Sucesso ? response.Mensagem : response.excecoes;
    if (message) { 
      mensagens.erro(message);
      return;
    }

    resolve(response);
  };
};

const _createFailHandler = (reject) => {
  return (error) => {
    mensagemHelper.esconderLoading();
    var message = error.Mensagem ? error.Mensagem : error.excecoes;
    if (message) {
      mensagens.erro(message);
      return;
    }
  
    mensagens.erro("Ocorreu um erro inesperado.");
    reject(error);
  }
};
